// extracted by mini-css-extract-plugin
export default {"smallViews":"SmallViews_smallViews__1GyQQ"};